module.exports = __webpack_public_path__ + "img/one.489f97e9.png";